<template>
  <div id="HomePage">
    <!-- 轮播图 -->
    <div id="swiper" class="container-fuild">
      <div class="swiper-container banner-swiper">
        <div class="swiper-wrapper">
          <div class="swiper-slide" v-for="(item,index) in swiperList" :key="index">
            <img class="swiper-lazy" :data-src="item.img" alt="轮播图">
            <div class="swiper-lazy-preloader"></div>
            <div class="swiper-slide-title">
                <h1>{{item.title}}</h1>
				<h2>{{item.titleen}}</h2>
                <p class="content">{{item.content}}</p>
				<p class="contenten">{{item.contenten}}</p>
            </div>
          </div>
        </div>
        <!-- 如果需要分页器 -->
        <div class="swiper-pagination"></div>

        <!-- 如果需要导航按钮 -->
        <div class="swiper-button-prev"></div>
        <div class="swiper-button-next"></div>
      </div>
    </div>
    <!-- Travellet 服务平台 -->
    <div id="bigData" class="container container-fuild">
      <div class="row bigData-container">
        <div class="col-xs-12 col-sm-12 col-md-6 wow zoomIn">
          <img class="img-responsive" src="@/assets/img/img1.png" alt="Travellet 服务平台">
        </div>
        <div class="col-xs-12 col-sm-12 col-md-6">
          <h2 class="bigData-title">
            Travellet 服务平台
            <small>/ Travellet Platform</small>
          </h2>
          <p>Travellet成立于2017年，目前团队约30人，东南亚总部位于胡志明市，于香港、中国大陆设有办公室</p>
		  <p>Travellet was established in 2017 and currently has a team of about 30 people. The Southeast Asia headquarters is located in Ho Chi Minh City, with offices in Hong Kong and Mainland China.</p>
          <p>Travellet立足东南亚，向全球业务拓展，力求为合作方提供一站式结算与服务平台</p>
		  <p>Based in Southeast Asia, Travellet expands to global business, and strives to provide partners with a one-stop service platform</p>
		  <p>合作伙伴可以简单快速的在Travellet体系内完成目标市场的本地合规、聚合支付接入、服务采购等等操作</p>
		  <p>Partners can co-publish with Travelllet, and easily complete operations such as local license Application, all-in-one payment access, marketing and service procurement, etc. in the target market within</p>
		  <p>为合作伙伴节省大量发行环节的商务法务与财务成本与时间</p>
		  <p>Save a lot of business,legal and financial costs and time in the process of publishing for partners</p>
<!--          <h2 class="bigData-device">PC/PAD/Phone &nbsp; 全设备支持</h2>
          <a href="#" class="btn btn-lg btn-block btn-info">联系我们</a> -->
        </div>
      </div>
    </div>
    <!-- 合作产品IT专家 -->
   <div id="contactUs" class="container-fuild text-center">
      <div class="container contactUs-container wow slideInUp">
        <h1>合作产品</h1>
		<p>Cooperated Products</p>
        <div class="contactUs-contactWay">
			<span v-for="(item,index) in gamelogo" :key="index">
				<img class="img-responsive" :src="item.logo" alt="Travellet">
				<br v-if="index==9">
			</span>
        </div>
      </div>
    </div>
	
    <!-- 客户评价 -->
<!--    <div id="customer" class="container-fuild">
      <div class="container customer-container">
        <p class="customer-title text-center">客户评价</p>
        <div class="swiper-container customer-swiper hidden-xs">
          <div class="swiper-wrapper">
            <div
              class="swiper-slide customer-block"
              v-for="(item,index) in customerList"
              :key="index"
            >
              <div class="customer-logo">
                <img class="center-block" :src="item.logo" alt="logo">
              </div>
              <div class="customer-yh">
                <img src="@/assets/img/yinhao.png" alt="引号">
              </div>
              <div class="customer-content1">
                <small>{{item.content}}</small>
              </div>
              <div class="customer-content2">{{item.title}}</div>
            </div>
          </div> -->
          <!-- 如果需要导航按钮 -->
<!--          <div class="swiper-button-prev"></div>
          <div class="swiper-button-next"></div>
        </div>
        <div class="row visible-xs customer-block">
          <div class="col-xs-12" v-for="(item,index) in customerList" :key="index">
            <div class="customer-logo">
              <img class="center-block" :src="item.logo" alt="logo">
            </div>
            <div class="customer-yh">
              <img src="@/assets/img/yinhao.png" alt="引号">
            </div>
            <div class="customer-content1">
              <small>{{item.content}}</small>
            </div>
            <div class="customer-content2">
              <small>{{item.title}}</small>
            </div>
          </div>
        </div>
      </div>
    </div> -->
    <!-- 为什么选择我们 -->
    <div id="whyChooseUs" class="conatiner-fuild">
      <div class="container">
        <div class="whyChooseUs-title text-center">
          <p>为什么选择我们的服务</p>
          <p>THE REASON TO CHOOSING US</p>
        </div>
        <div class="row">
          <div
            class="col-xs-12 col-sm-6 col-md-3 server-wrapper"
            v-for="(item,index) in serverList"
            :key="index"
          >
            <div
              class="server-block wow slideInUp"
              onmouseenter="this.style.color='#28f';this.style.borderColor='#28f'"
              onmouseleave="this.style.color='#666';this.style.borderColor='#ccc'"
            >
              <img class="center-block" :src="item.logo" alt="logo">
              <p class="text-center">{{item.title}}</p>
			  <p class="text-center">{{item.titleen}}</p>
              <div
                class="text-center"
                v-html="item.content"
                onmouseenter="this.style.color='#28f'"
                onmouseleave="this.style.color='#ccc'"
              ></div>
			  <div
			    class="text-center"
			    v-html="item.contenten"
			    onmouseenter="this.style.color='#28f'"
			    onmouseleave="this.style.color='#ccc'"
			  ></div>
            </div>
          </div>
        </div>
      </div>
    </div>
	<!-- 合作客户 -->
	<div class="container clientarr">
		<h1 class="pao-title">合作客户</h1>
		<p>Our Clients</p>
		<vue-marquee style="height:150px" :showProgress="false">
		  <vue-marquee-slide v-for="(item, index) in clientarr" :key="index">
			  <img :src="item.logo">
		  </vue-marquee-slide>
		</vue-marquee>
	</div>
	<!-- 合作支付通道 -->
	<div class="container paychannel">
		<h1 class="pao-title">合作支付通道</h1>
		<p>Our Payment Channel</p>
		<div>
			<img :class="{'big':index==7}" v-for="(item, index) in paychannelList" :key="index" :src="item.logo">
		</div>
	</div>
  </div>
</template>
<script>
import Swiper from "swiper";
import { WOW } from 'wowjs';

// 跑马灯
import { Marquee, Slide } from 'vue-marquee-component';

export default {
  name: "HomePage",
  components: {
	[Marquee.name]: Marquee,
	[Slide.name]: Slide
  },
  data() {
    return {
		clientarr: [
			{
			logo: require("@/assets/img/client/1.jpg"),
		},{
			logo: require("@/assets/img/client/2.jpg"),
		},{
			logo: require("@/assets/img/client/3.jpg"),
		},{
			logo: require("@/assets/img/client/4.jpg"),
		},{
			logo: require("@/assets/img/client/5.jpg"),
		},{
			logo: require("@/assets/img/client/6.jpg"),
		},{
			logo: require("@/assets/img/client/7.jpg"),
		},{
			logo: require("@/assets/img/client/8.jpg"),
		}],
		paychannelList:[
			{
				logo: require("@/assets/img/pay/0.png"),
			},
			{
				logo: require("@/assets/img/pay/2.png"),
			},
			{
				logo: require("@/assets/img/pay/3.png"),
			},
			{
				logo: require("@/assets/img/pay/4.png"),
			},
			{
				logo: require("@/assets/img/pay/5.png"),
			},
			{
				logo: require("@/assets/img/pay/6.png"),
			},
			{
				logo: require("@/assets/img/pay/7.png"),
			},
			{
				logo: require("@/assets/img/pay/8.png"),
			}
		],
      swiperList: [
        {
          img: require("@/assets/img/banner1.png"),
          path: "",
          title: '高效可靠的一站式出海本地支持服务平台',
		  titleen:'Efficient and reliable one-stop overseas publishing service platform',
          content: '为您提供互联网产品的本地合规、聚合支付、本地市场、以及本地化翻译、客服与私有云服务',
		  contenten:'Providing you with Local Policy consultation, All-in-one payment API, Local marketing, localization, Customer service and Private cloud services for overseas publishing of Internet products',
        },
        {
          img: require("@/assets/img/banner2.jpg"),
          path: "",
          title: '高效可靠的一站式出海本地支持服务平台',
		  titleen:'Efficient and reliable one-stop overseas publishing service platform',
          content: '为您提供互联网产品的本地合规、聚合支付、本地市场、以及本地化翻译、客服与私有云服务',
		  contenten:'Providing you with Local Policy consultation, All-in-one payment API, Local marketing, localization, Customer service and Private cloud services for overseas publishing of Internet products',
        }
      ],
	  gamelogo:[
		{
			logo: require("@/assets/img/gamelogo/1.png"),
		},
		{
			logo: require("@/assets/img/gamelogo/2.png"),
		},
		{
			logo: require("@/assets/img/gamelogo/3.png"),
		},
		{
			logo: require("@/assets/img/gamelogo/4.png"),
		},
		{
			logo: require("@/assets/img/gamelogo/5.png"),
		},
		{
			logo: require("@/assets/img/gamelogo/6.png"),
		},
		{
			logo: require("@/assets/img/gamelogo/7.png"),
		},
		{
			logo: require("@/assets/img/gamelogo/8.png"),
		},
		{
			logo: require("@/assets/img/gamelogo/9.png"),
		},
		{
			logo: require("@/assets/img/gamelogo/10.png"),
		},
		{
			logo: require("@/assets/img/gamelogo/11.png"),
		},
		{
			logo: require("@/assets/img/gamelogo/12.png"),
		},
		{
			logo: require("@/assets/img/gamelogo/13.png"),
		},
		{
			logo: require("@/assets/img/gamelogo/14.png"),
		},
		{
			logo: require("@/assets/img/gamelogo/15.png"),
		},
		{
			logo: require("@/assets/img/gamelogo/16.png"),
		},
		{
			logo: require("@/assets/img/gamelogo/17.png"),
		},
		{
			logo: require("@/assets/img/gamelogo/18.png"),
		},
		{
			logo: require("@/assets/img/gamelogo/19.png"),
		},
		{
			logo: require("@/assets/img/gamelogo/20.png"),
		},
	  ],
      customerList: [
        {
          logo: require("@/assets/img/logo_hp.png"),
          title:
            "您可以双击这里或者点击编辑按钮来修改内容。您还可以添加图标，按钮，图片等常用元素。",
          content:
            "您可以双击这里或者点击编辑按钮来修改内容。您还可以添加图标，按钮，图片等常用元素。您可以双击这里或者点击编辑按钮来修改内容。您还可以添加图标，按钮，图片等常用元素。"
        },
        {
          logo: require("@/assets/img/logo_kk.png"),
          title:
            "您可以双击这里或者点击编辑按钮来修改内容。您还可以添加图标，按钮，图片等常用元素。",
          content:
            "您可以双击这里或者点击编辑按钮来修改内容。您还可以添加图标，按钮，图片等常用元素。您可以双击这里或者点击编辑按钮来修改内容。您还可以添加图标，按钮，图片等常用元素。"
        },
        {
          logo: require("@/assets/img/logo_toyota.png"),
          title:
            "您可以双击这里或者点击编辑按钮来修改内容。您还可以添加图标，按钮，图片等常用元素。",
          content:
            "您可以双击这里或者点击编辑按钮来修改内容。您还可以添加图标，按钮，图片等常用元素。您可以双击这里或者点击编辑按钮来修改内容。您还可以添加图标，按钮，图片等常用元素。"
        },
        {
          logo: require("@/assets/img/logo_kk.png"),
          title:
            "您可以双击这里或者点击编辑按钮来修改内容。您还可以添加图标，按钮，图片等常用元素。",
          content:
            "您可以双击这里或者点击编辑按钮来修改内容。您还可以添加图标，按钮，图片等常用元素。您可以双击这里或者点击编辑按钮来修改内容。您还可以添加图标，按钮，图片等常用元素。"
        },
        {
          logo: require("@/assets/img/logo_hp.png"),
          title:
            "您可以双击这里或者点击编辑按钮来修改内容。您还可以添加图标，按钮，图片等常用元素。",
          content:
            "您可以双击这里或者点击编辑按钮来修改内容。您还可以添加图标，按钮，图片等常用元素。您可以双击这里或者点击编辑按钮来修改内容。您还可以添加图标，按钮，图片等常用元素。"
        },
        {
          logo: require("@/assets/img/logo_toyota.png"),
          title:
            "您可以双击这里或者点击编辑按钮来修改内容。您还可以添加图标，按钮，图片等常用元素。",
          content:
            "您可以双击这里或者点击编辑按钮来修改内容。您还可以添加图标，按钮，图片等常用元素。您可以双击这里或者点击编辑按钮来修改内容。您还可以添加图标，按钮，图片等常用元素。"
        },
        {
          logo: require("@/assets/img/logo_kk.png"),
          title:
            "您可以双击这里或者点击编辑按钮来修改内容。您还可以添加图标，按钮，图片等常用元素。",
          content:
            "您可以双击这里或者点击编辑按钮来修改内容。您还可以添加图标，按钮，图片等常用元素。您可以双击这里或者点击编辑按钮来修改内容。您还可以添加图标，按钮，图片等常用元素。"
        },
        {
          logo: require("@/assets/img/logo_hp.png"),
          title:
            "您可以双击这里或者点击编辑按钮来修改内容。您还可以添加图标，按钮，图片等常用元素。",
          content:
            "您可以双击这里或者点击编辑按钮来修改内容。您还可以添加图标，按钮，图片等常用元素。您可以双击这里或者点击编辑按钮来修改内容。您还可以添加图标，按钮，图片等常用元素。"
        },
        {
          logo: require("@/assets/img/logo_toyota.png"),
          title:
            "您可以双击这里或者点击编辑按钮来修改内容。您还可以添加图标，按钮，图片等常用元素。",
          content:
            "您可以双击这里或者点击编辑按钮来修改内容。您还可以添加图标，按钮，图片等常用元素。您可以双击这里或者点击编辑按钮来修改内容。您还可以添加图标，按钮，图片等常用元素。"
        },
        {
          logo: require("@/assets/img/logo_hp.png"),
          title:
            "您可以双击这里或者点击编辑按钮来修改内容。您还可以添加图标，按钮，图片等常用元素。",
          content:
            "您可以双击这里或者点击编辑按钮来修改内容。您还可以添加图标，按钮，图片等常用元素。您可以双击这里或者点击编辑按钮来修改内容。您还可以添加图标，按钮，图片等常用元素。"
        },
        {
          logo: require("@/assets/img/logo_kk.png"),
          title:
            "您可以双击这里或者点击编辑按钮来修改内容。您还可以添加图标，按钮，图片等常用元素。",
          content:
            "您可以双击这里或者点击编辑按钮来修改内容。您还可以添加图标，按钮，图片等常用元素。您可以双击这里或者点击编辑按钮来修改内容。您还可以添加图标，按钮，图片等常用元素。"
        },
        {
          logo: require("@/assets/img/logo_hp.png"),
          title:
            "您可以双击这里或者点击编辑按钮来修改内容。您还可以添加图标，按钮，图片等常用元素。",
          content:
            "您可以双击这里或者点击编辑按钮来修改内容。您还可以添加图标，按钮，图片等常用元素。您可以双击这里或者点击编辑按钮来修改内容。您还可以添加图标，按钮，图片等常用元素。"
        }
      ],
      serverList: [
        {
          logo: require("@/assets/img/server/dn-th6.png"),
          title: "高效且富有经验的团队",
		  titleen:"Highly efficient and experienced team",
          content: "<p>自营拥有十年以上经验的多语种服务团队</p><p>为您提供从技术到翻译、客服的优秀服务体验</p>",
		  contenten:"Self-owned multilingual service team with more than ten years of experience<p>Providing you with excellent experience from technology to translation and customer service</p>"
        },
        {
          logo: require("@/assets/img/server/dn-th2.png"),
          title: "安全可靠高效的技术平台",
		  titleen:"Safe, reliable and efficient technology platform",
          content: "<p>金融级别的聚合支付平台，高安全性与稳定性</p><p>简单接入api,则可打通全部业务地区数十家支付通道，高效简便</p>",
			contenten:"Financial-grade aggregated payment platform, high security and stability<p>Simply access to our api, you can open up dozens of payment channels in all business areas, efficient and simple</p>"
		},
        {
          logo: require("@/assets/img/server/icon-bill.png"),
          title: "成本控制优秀的本地资源",
		  titleen:"Procurement of local resources with excellent cost control",
          content: "<p>多年的发行经验获取了当地性价比较高的发行资源</p><p>为合作伙伴提供成本有竞争力的本地市场、服务器等代采购服务</p>",
        contenten:"Years of publishing experience has got local resources with competitive cost<P>Providing partners with cost-competitive local market and server procurement services</p>"
		},
        {
          logo: require("@/assets/img/server/chon2.png"),
          title: "合规稳定的结算金流",
		  titleen:"Low-risk and stable settlement gold flow",
          content: "<p>合作金流合规稳定结算长达四年之久</p><p>得力于稳定的风控与合规系统，基本无坏账</p>",
		  contenten:"Cooperated products have low risk and stable settlement for up to four years<P>Powered by a stable risk control and legal system, basically no bad debts</p>"
        }
      ]
    };
  },
  mounted() {
    /* banner-swiper */
    new Swiper(".banner-swiper", {
      loop: true, // 循环模式选项
      effect: 'fade',
      //自动播放
      autoplay: {
        delay: 3000,
        stopOnLastSlide: false,
        disableOnInteraction: false
      },
      // 如果需要分页器
      pagination: {
        el: ".swiper-pagination",
        clickable: true
      },
      // 如果需要前进后退按钮
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev"
      },
      // 延迟加载
      lazy: {
        loadPrevNext: true
      },
      observer: true, //修改swiper自己或子元素时，自动初始化swiper
      observeParents: true //修改swiper的父元素时，自动初始化swiper
    });
    /* customer-swiper */
    new Swiper(".customer-swiper", {
      loop: true, // 循环模式选项
      slidesPerView: 3,
      //自动播放
      autoplay: {
        delay: 3000,
        stopOnLastSlide: false,
        disableOnInteraction: false
      },
      // 如果需要前进后退按钮
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev"
      },
      observer: true, //修改swiper自己或子元素时，自动初始化swiper
      observeParents: true //修改swiper的父元素时，自动初始化swiper
    });
    /* wowjs动画 */
    var wow = new WOW({
      boxClass: 'wow',
      animateClass: 'animated',
      offset: 0,
      mobile: true,
      live: true
    })
    wow.init();
  }
};
</script>
<style scoped>
/* 整体盒子 */
#HomePage {
  width: 100%;
}

/* 轮播图 */
#swiper {
  height: 600px;
}
#swiper .banner-swiper {
  width: 100%;
  height: 100%;
}
#swiper .banner-swiper .swiper-slide img {
  width: 100%;
  height: 100%;
}
#swiper .banner-swiper .swiper-slide{
  position: relative;
}
#swiper .banner-swiper .swiper-slide-title {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 999999999;
  width: 100%;
  height: 100%;
  color: #fff;
  background: rgba(51, 51, 51, 0.534);
  text-align: center;
  line-height: 80px;
  display: flex;
  flex-direction:column;
  justify-content:center;
}
#swiper .banner-swiper .swiper-slide-title > h1{
  font-size: 50px;
}
#swiper .banner-swiper .swiper-slide-title > p{
	line-height: 35px;
	margin: 0;
  font-size: 20px;
}
#swiper .banner-swiper .swiper-slide-title > p.content{
	margin-top: 20px;
  font-size: 20px;
}
#swiper .banner-swiper .swiper-slide-title > p.contenten{
  font-size: 12px;
}

/* 大数据管理系统 */
#bigData {
  padding: 100px;
  transition: all ease 0.6s;
  box-sizing: border-box;
}
#bigData .bigData-title {
  padding-bottom: 10px;
  border-bottom: 1px solid #ccc;
}
#bigData p {
  font-size: 14px;
  color: #333;
  line-height: 2rem;
}
#bigData .bigData-device {
  margin: 50px 0 20px;
}

/* 合作产品 */
#contactUs {
  color: #fff;
  background-color:#f4f4f4;
  /* height: 400px; */
  /* background: url("../assets/img/contact_us_bg.jpg") 0 0 no-repeat; */
  background-size: 100% 100%;
  transition: all ease 0.6s;
}
#contactUs .contactUs-container {
	color: #333;
  padding-top: 20px;
}
#contactUs .contactUs-container button {
  width: 300px;
  height: 50px;
  margin-top: 40px;
}
#contactUs .contactUs-container .contactUs-contactWay img {
  display: inline-block;
  width: 48px;
  /* height: 48px; */
  margin: 20px;
}

/* #contactUs .contactUs-container .contactUs-contactWay span:nth-of-type(1) {
  background: url("../assets/img/weixin.png") 0 0 no-repeat;
  background-size: 100% 100%;
}
#contactUs .contactUs-container .contactUs-contactWay span:nth-of-type(2) {
  background: url("../assets/img/weibo.png") 0 0 no-repeat;
  background-size: 100% 100%;
}
#contactUs .contactUs-container .contactUs-contactWay span:nth-of-type(3) {
  background: url("../assets/img/twitter.png") 0 0 no-repeat;
  background-size: 100% 100%;
} */

/* 客户评价 */
#customer {
  padding: 50px 0;
  box-sizing: border-box;
  background: #efefef;
  transition: all ease 0.6s;
}
#customer .customer-title {
  font-size: 30px;
  color: rgb(102, 102, 102);
  margin: 0 0 30px;
}
#customer .customer-block {
  background: #fff;
  padding: 30px;
}
#customer .customer-logo img {
  width: 94px;
  height: 94px;
  border: 1px solid #ccc;
}
#customer .customer-yh img {
  width: 34px;
  height: 34px;
}
#customer .customer-content1 {
  padding-bottom: 20px;
  border-bottom: 1px solid #0ce9f1;
}
#customer .customer-content2 {
  padding-top: 20px;
}
/* 为什么选择我们 */
#whyChooseUs {
  padding: 100px;
}
#whyChooseUs .whyChooseUs-title {
  margin-bottom: 50px;
}
#whyChooseUs .whyChooseUs-title p:nth-of-type(1) {
  font-size: 25px;
  font-weight: 500;
}
#whyChooseUs .whyChooseUs-title p:nth-of-type(2) {
  font-size: 14px;
}
#whyChooseUs .server-block {
  padding: 50px 20px;
  border: 1px solid #ccc;
  border-bottom: 5px solid #ccc;
}
#whyChooseUs .server-block img {
  width: 48px;
  height: 48px;
}
#whyChooseUs .server-block > p {
  font-size: 20px;
  margin: 30px 0;
}
#whyChooseUs .server-block > div {
  color: #ccc;
}

/* 合作客户 */
.clientarr{
	text-align: center;
}
.clientarr img{
	width: 158px;
	/* height: 94px; */
	margin: 0 20px;
	display: inline-block;
}
.clientarr .pao-title{
	text-align: center;
	margin: 0 0 20px 0;
}
.paychannel{
	text-align: center;
}
.paychannel img{
	height: 47px;
	margin: 20px;
	display: inline-block;
}
.paychannel .big{
	height: 150px;
}
.paychannel .pao-title{
	text-align: center;
	margin: 0 0 20px 0;
}

/* 媒体查询（手机） */
@media screen and (max-width: 768px) {
  #swiper {
    height: 200px;
  }
  #bigData {
    padding: 30px;
  }
  #bigData .bigData-title {
    font-size: 20px;
  }
  #bigData .bigData-device {
    font-size: 20px;
    margin: 10px 0 10px;
  }
  #swiper .banner-swiper .swiper-slide-title > h1{
	  margin-bottom: 0;
    font-size: 14px;
  }
  #swiper .banner-swiper .swiper-slide-title > h2{
    font-size: 12px;
  }
  #swiper .banner-swiper .swiper-slide-title > p.content{
	  margin: 0;
    font-size: 12px;
	line-height: 24px;
  }
  #swiper .banner-swiper .swiper-slide-title > p.contenten{
    font-size: 12px;
  	line-height: 24px;
  }
  .paychannel img{
  	height: 45px;
  }
  .paychannel .big{
	margin: 20px 0;
  	height: 66px;
  }
  #contactUs {
    /* height: 200px; */
    transition: all ease 0.6s;
  }
  #contactUs .contactUs-container {
    padding-top: 0;
  }
  #contactUs .contactUs-container h1 {
    font-size: 25px;
  }
  #contactUs .contactUs-container h3 {
    font-size: 18px;
  }
  #contactUs .contactUs-container button {
    width: 200px;
    height: 30px;
    margin-top: 20px;
  }
    #contactUs .contactUs-container .contactUs-contactWay{
		margin: 0 0 10px 0;
	}
  #contactUs .contactUs-container .contactUs-contactWay span {
    display: inline-block;
    width: 48px;
    height: 48px;
    margin:-20px 40px 40px 0;
  }
  #customer {
    padding: 30px 0;
    box-sizing: border-box;
    background: #fff;
  }
  #customer .customer-title {
    font-size: 16px;
    font-weight: bold;
  }
  #customer .customer-logo img {
    width: 48px;
    height: 48px;
  }
  #customer .customer-block {
    padding: 30px;
  }
  #customer .customer-block > div {
    padding: 30px 0;
  }
  #whyChooseUs {
    padding: 20px 0;
    transition: all ease 0.6s;
  }
  #whyChooseUs .whyChooseUs-title p:nth-of-type(1) {
    font-size: 20px;
    font-weight: 700;
  }
  #whyChooseUs .whyChooseUs-title p:nth-of-type(2) {
    font-size: 12px;
  }
  #whyChooseUs .server-block {
    padding: 50px 0;
    border: 1px solid #ccc;
    border-bottom: 5px solid #ccc;
  }
  #whyChooseUs .server-block img {
    width: 48px;
    height: 48px;
  }
  #whyChooseUs .server-block > p {
    font-size: 20px;
    margin: 30px 0;
  }
  #whyChooseUs .server-block > div {
    color: #ccc;
  }
}

/* 媒体查询（平板） */
@media screen and (min-width: 768px) and (max-width: 996px) {
  #swiper {
    height: 400px;
  }
  #bigData {
    padding: 60px;
  }
  #bigData .bigData-title {
    font-size: 30px;
  }
  #bigData .bigData-device {
    font-size: 30px;
    margin: 30px 0 15px;
  }
  .paychannel img{
  	height: 60px;
  }
  #contactUs {
    height: 300px;
  }
  #contactUs .contactUs-container {
    padding-top: 50px;
  }
  #contactUs .contactUs-container h1 {
    font-size: 30px;
  }
  #contactUs .contactUs-container h3 {
    font-size: 20px;
  }
  #contactUs .contactUs-container button {
    width: 300px;
    height: 50px;
    margin-top: 30px;
  }
  #contactUs .contactUs-container .contactUs-contactWay span {
    display: inline-block;
    width: 32px;
    height: 32px;
    margin: 15px;
  }
  #customer .customer-title {
    font-size: 24px;
  }
  #whyChooseUs {
    padding: 20px 0;
  }
}
</style>




// WEBPACK FOOTER //
// src/view/HomePage.vue